// extracted by mini-css-extract-plugin
export default {"Contact":"Contact_Contact__39776","form":"Contact_form__UDLpH","container":"Contact_container__0ubbc","invalid":"Contact_invalid__f0J0Q","errorText":"Contact_errorText__etk9h"};